/**
 * Built-in plugin: surfaces skills that use the Router pattern.
 * Router skills are dispatch-style: small SKILL.md that references
 * multiple topic files.
 */

import { registerPlugin } from "../types";
import type { Skill } from "../../types";
import { createElement } from "react";

registerPlugin({
  id: "router-pattern",
  name: "Router Pattern",
  description: "Detects skills that use the Router dispatch pattern.",
  facets(skill: Skill) {
    return { isRouter: skill.hasRouter };
  },
  facetFilters: [
    {
      id: "isRouter",
      label: "Router pattern",
      match: (s) => Boolean(s.hasRouter || s.facets?.isRouter),
    },
  ],
  DetailSection({ skill }) {
    const isRouter = skill.hasRouter;
    const label = isRouter ? "ACTIVE" : "INACTIVE";
    const color = isRouter ? "text-good font-bold" : "text-muted";
    const desc = isRouter 
      ? "Uses a small dispatch SKILL.md referencing multiple topic files."
      : "Single large SKILL.md file.";
    return createElement("div", { className: "font-mono text-[11px] flex flex-col gap-2 mt-1" }, [
      createElement("div", { key: "status", className: "flex justify-between border-b border-rule py-1.5" },
        createElement("span", {}, "Router Pattern:"),
        createElement("span", { className: color }, label)
      ),
      createElement("div", { key: "desc", className: "text-muted leading-[1.4] py-1" }, desc),
    ]);
  }
});
